import { VIDEO_READY_V1_PREFIX } from '@bg-shared/constants/socketChannels';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { GameId } from '@bg-shared/enums/GameId';
import { IVideoReadyEvent } from './interfaces';

export default class VODService {
    public subscribe(gameId: GameId, listener: (data: IVideoReadyEvent) => void): () => void {
        const channel = `${VIDEO_READY_V1_PREFIX}${gameId}`;

        const unsubscribe = webSocketsRepository.on<IVideoReadyEvent>(channel, listener);

        webSocketsRepository.emitLast(channel, listener);

        return unsubscribe;
    }
}

export const vodService = new VODService();
